export default __webpack_public_path__ + "static/media/5 Embassy & Manpower Department.ae3a3048.jpg";